/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-implant-stock.reducer';

export const PharmacyImplantStockDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyImplantStockEntity = useAppSelector(state => state.pharmacyImplantStock.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyImplantStockDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.detail.title">PharmacyImplantStock</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.id}</dd>
          <dt>
            <span id="brandId">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.brandId">Brand Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.brandId}</dd>
          <dt>
            <span id="stockQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.stockQty">Stock Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.stockQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.expDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.cursor}</dd>
          <dt>
            <span id="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.batchNumber">Batch Number</Translate>
            </span>
            <UncontrolledTooltip target="batchNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.batchNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantStockEntity.batchNumber}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.taxCode}</dd>
          <dt>
            <span id="mrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.mrp">Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.mrp}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.price">Price</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.price}</dd>
          <dt>
            <span id="remainingQuantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.remainingQuantity">Remaining Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.remainingQuantity}</dd>
          <dt>
            <span id="serialNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.serialNumber">Serial Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.serialNumber}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.packs}</dd>
          <dt>
            <span id="HSNCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.HSNCode">HSN Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.HSNCode}</dd>
          <dt>
            <span id="rack">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.rack">Rack</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.rack}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.discount}</dd>
          <dt>
            <span id="available">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.available">Available</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.available ? 'true' : 'false'}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="shipmentItemId">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.shipmentItemId">Shipment Item Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.shipmentItemId}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.modifiedByType}</dd>
          <dt>
            <span id="margin">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.margin">Margin</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantStockEntity.margin}</dd>
          <dt>
            <span id="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.cessAmount">Cess Amount</Translate>
            </span>
            <UncontrolledTooltip target="cessAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.cessAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantStockEntity.cessAmount}</dd>
          <dt>
            <span id="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.exempted">Exempted</Translate>
            </span>
            <UncontrolledTooltip target="exempted">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.exempted" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantStockEntity.exempted ? 'true' : 'false'}</dd>
          <dt>
            <span id="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.importDuty">Import Duty</Translate>
            </span>
            <UncontrolledTooltip target="importDuty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.importDuty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantStockEntity.importDuty}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyImplantStockEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyImplantStockEntity.pharmacy ? pharmacyImplantStockEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.implant">Implant</Translate>
          </dt>
          <dd>{pharmacyImplantStockEntity.implant ? pharmacyImplantStockEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyImplantStockEntity.supplier ? pharmacyImplantStockEntity.supplier.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.bill">Bill</Translate>
          </dt>
          <dd>{pharmacyImplantStockEntity.bill ? pharmacyImplantStockEntity.bill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantStock.uqcType">Uqc Type</Translate>
          </dt>
          <dd>{pharmacyImplantStockEntity.uqcType ? pharmacyImplantStockEntity.uqcType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-implant-stock" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-implant-stock/${pharmacyImplantStockEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyImplantStockDetail;
